import React from 'react';

const ActivityFeedIcon = ({ iconName }) => <div className={`sidebar-item-icon ${iconName}`} />;

export default ActivityFeedIcon;
